/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actiontypes from './actiontypes';

const initialState = {
  all_rebate: false,
  err_list: [],
  flderror: {},
  plan_type: '',
  rebate_pgm: '',
  ura_to_use: 'Official',
  display_by: 'Manufacturer',
  qtr_opt: 'All',
  all_manu: true,
  firstload: true,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actiontypes.ACC_ERR_MSG:
      return { ...state, err_list: [...action.payload] };
    case actiontypes.ACC_FLD_ERR:
      return { ...state, flderror: action.payload };
    case actiontypes.ACC_PLAN_LIST:
      return { ...state, plan_list: action.payload };
    case actiontypes.ACC_REBARE_LIST:
      return { ...state, rebate_list: action.payload };
    case actiontypes.ACC_PLAN_TYPE:
      return { ...state, plan_type: action.payload };
    case actiontypes.ACC_REBATE_PGM:
      return { ...state, rebate_pgm: action.payload };
    case actiontypes.ACC_URA_TO_USE:
      return { ...state, ura_to_use: action.payload };
    case actiontypes.ACC_DISPLAY_BY:
      return { ...state, display_by: action.payload };
    case actiontypes.ACC_QTR_OPT:
      return { ...state, qtr_opt: action.payload };
    case actiontypes.FIRST_LOAD:
      return { ...state, firstload: false };
    case actiontypes.ACC_FROM_QTR:
      return { ...state, acc_qtr_from: action.payload };

    case actiontypes.ACC_TO_QTR:
      return { ...state, acc_qtr_to: action.payload };

    case actiontypes.ACC_ALL_REBATE:
      return { ...state, all_rebate: action.payload };
    case actiontypes.ACC_MANU_SELECT:
      return { ...state, all_manu: action.payload };
    case actiontypes.ACC_MANU_LIST:
      return { ...state, manu_list: action.payload };
    case actiontypes.ACC_END_QTR:
      return { ...state, end_qtr: action.payload };
    case actiontypes.ACC_START_QTR:
      return { ...state, start_qtr: action.payload };
    case actiontypes.ACC_RESET_STORE:
      return { ...state, ...initialState, start_qtr: '', err_list: '' };
    case actiontypes.AR_SMRY_FOR_MFG:
      return { ...state, ar_smry_mfg: action.payload };
    case actiontypes.AR_SMRY_FOR_QTR:
      return { ...state, ar_smry_qtr: action.payload };
    case actiontypes.REBATE_LIST_BY_PLAN:
      return { ...state, rbt_list: action.payload };
    case actiontypes.MFG_AR_ALL_RPC:
      return { ...state, mfg_all_rpc: action.payload };
    case actiontypes.CLEAR_REQ_ACC_REC_SEARCH_PAGE:
      return { ...initialState, ...action.payload };
    default:
      return state;
  }
};

export default reducer;
